// Coordinates are in the 1440 × 900 battlefield; scans and props keep their original proportions.
export const FIELD = {
  opponentY:86, playerY:489, rowHeight:323,
  mpX:260, mpOffsetY:159, mpWidth:192, mpHeight:192*343/250,
  handY:931, handWidth:174, handHeight:174*343/250, handHoverWidth:250,
  deckX:1370, dividerY:450, actionY:418,
};

// Measured centers of the printed power rows in the original 250 × 343 scans, stage 0 through 10.
const POWER_ROWS:Record<string,number[]> = {
  ss104:[277.5,253.6,229.7,205.7,181.8,157.9,134,110,86.1,62.2,38.3],
  ss243:[277.5,253.6,229.8,205.8,181.9,158,134.1,110.2,86.2,62.3,38.5],
  ss161:[277.71,253.88,229.98,205.89,182.02,157.94,134.09,110.18,86.14,62.23,38.55],
  ss162:[277.57,253.96,229.79,205.87,181.93,157.91,134.07,109.96,85.96,62.34,38.44],
  ss163:[277.43,253.88,229.91,206.08,182.34,158.82,134.88,111.02,87.25,63.59,40.02],
  ss170:[276.96,253.33,229.38,205.50,181.93,158.19,134.68,110.68,87.23,63.30,39.35],
  ss171:[277.05,253.13,229.10,205.60,181.37,157.96,133.84,110.06,85.97,62.46,38.59],
  ss172:[277,253.02,229.01,205.38,180.92,157.45,133.37,109.47,85.19,61.78,37.51],
};

export function allyPowerWindow(cardId:string,stage:number){
  const scale=144/250;
  return {x:(221-125)*scale,y:((POWER_ROWS[cardId]?.[stage]??277.7-stage*23.9)-343/2)*scale,width:48*scale,height:16*scale};
}

export function scouterPosition(cardId:string,stage:number,rowY:number){
  const scanScale=FIELD.mpWidth/250;
  const windowX=FIELD.mpX-FIELD.mpWidth/2+221*scanScale;
  const windowY=rowY+FIELD.mpOffsetY-FIELD.mpHeight/2+(POWER_ROWS[cardId]?.[stage]??277.7-stage*23.9)*scanScale;
  const scale=44*scanScale/220;
  // The existing PNG's clear aperture is centered at (287,425) in its 1246 × 1262 canvas.
  return {x:windowX-287*scale,y:windowY-425*scale,scale,windowX,windowY};
}
